import { styles, utils } from 'gipsy-misc'

/* used to customize event design in all views (background-color etc ...) */
export const eventPropGetter = (event, start, end, isSelected) => {
  const index = event.index
  const style = {
    color: event.color ? 'white' : styles.colors.textRegularColor,
    backgroundColor: event.color ? event.color : 'white',
    padding: '2px 10px',
    flexDirection: 'row',
    opacity: 0,
    animation: `calendarItemAppearAnimation 0.05s linear ${0.02 * index + 0.3}s forwards`
  }
  if (!event.allDay) {
    style.borderRight = event.color ? event.color : 'white'
  }
  return {
    className: `event-container`,
    style
  }
}

/* used to customize time slot design in all views (background-color etc ...) */
export const timeSlotPropGetter = (date, resourceId, weeklyWorkingHours) => {
  const isInsideWorkingHours = utils.datetime.isDateInsideWorkingHours(date, weeklyWorkingHours)
  return {
    className: 'time-slot-prop',
    style: {
      backgroundColor: isInsideWorkingHours ? 'inherit' : '#DBDBDB',
      height: '49px'
    }
  }
}



// WEBPACK FOOTER //
// ./src/features/calendar/getters.js